import { coreRequest } from "@kivra/sdk/common";
import type {
  BECompletionsV4,
  BECompletionV4,
} from "@kivra/sdk/types/core/completion";
import type {
  BackendSentEmailOtp,
  BackendSentPhoneOtp,
} from "@kivra/sdk/types/core/otp";

/**
 * TODO: Unify these requests with the other requests that we have.
 * Right now these are using coreRequests that aren't really utilized elsewhere
 * ! Can't be done currently as `getApiRoot()` defaults to API v1;
 * ! Competion here requires v4
 */

/**
 * List user completions
 */

// userKeys here are prefixed with `user` which is incorrect
// `coreRequest` doesn't follow the API URL set in config

export async function getUserCompletion(
  userKey: string,
  accessToken: string,
): Promise<BECompletionsV4> {
  return coreRequest.get<BECompletionsV4>({
    path: `/v4/user/${userKey}/completion`,
    accessToken,
  });
}

/**
 * Updates user completion
 */
export async function setUserCompletion(
  userKey: string,
  accessToken: string,
  completion:
    & Pick<BECompletionV4, "context" | "type">
    & ({ action: "postpone" } | { action: "confirm"; confirmed: string }),
): Promise<BECompletionV4[]> {
  return coreRequest.put<BECompletionV4[]>({
    path: `/v4/user/${userKey}/completion`,
    accessToken,
    payload: completion,
  });
}

/**
 * Requests one time password for the current user
 */
export function requestSmsOtpV3(
  userKey: string,
  accessToken: string,
  phoneNumber: string,
): Promise<BackendSentPhoneOtp> {
  return coreRequest.post({
    path: `/v3/user/${userKey}/otp`,
    accessToken,
    payload: { phone: phoneNumber },
  });
}

/**
 * Requests one time password for the current user
 */
export function requestEmailOtpV3(
  userKey: string,
  accessToken: string,
  email: string,
): Promise<BackendSentEmailOtp> {
  return coreRequest.post({
    path: `/v3/user/${userKey}/otp`,
    accessToken,
    payload: { email },
  });
}

// These are used when the completions are submitted
// TODO: Is V3 correct for these?
/**
 * Updates the user mobile phone number
 * Expected errors:
 *  - Validation error (40005) ApiResponseError
 *  - BankId expired error (40027) ApiResponseError
 */
export function updatePhoneNumberV3(
  userKey: string,
  accessToken: string,
  phonenumber: string,
  otp: string,
  context: BECompletionV4["context"],
): Promise<void> {
  return coreRequest.put({
    path: `/v3/user/${userKey}/phone`,
    accessToken,
    payload: { phone: phonenumber, otp, context },
  });
}

/**
 * Updates the user email.
 * Expected errors:
 *  - Validation error (40007) ApiResponseError
 *  - BankId expired error (40027) ApiResponseError
 */
export function updateUserEmailV3(
  userKey: string,
  accessToken: string,
  email: string,
  otp: string,
  context: BECompletionV4["context"],
): Promise<void> {
  return coreRequest.put({
    path: `/v3/user/${userKey}/email`,
    accessToken,
    payload: { email, otp, context },
  });
}
